import { getSubdomain } from '../services/utils'
import { instanceChatApi } from './instances'

export const getMessages = async () => {
    const subdomain = getSubdomain()
    return await instanceChatApi.get(`/${subdomain}/messages`)
}
